<template>
    <div  ref="filterMain"  class="search-filter" :class="{'resetFilter': needRest}"  :comp="$options.name">
        <div class="search-filter-main">
            <div ref="filterScroll" class="scroller">
                <div data-allow-mismatch="children">
                    <a v-for="item in glb.filterLabel"
                        :key="item.id"
                        :data-id="item.id"
                        :order="item.order"
                        class="btn small filter"
                        :class="{ active: item.changed, filterRedesignEnabled: isFilterRedesignEnabled(item), square: isFilterRedesignEnabled(item), 'mvt-dropdown__toggle': isFilterRedesignEnabled(item) }"
                        v-show="!item.hide"
                        @click="searchFilterToggle($event, item)"
                        role="button"
                    >
                       <span>
                        <span v-html="item.label"></span>
                        <i v-if="isFilterRedesignEnabled(item) && !item.changed" :class="{ 'icon-angle-up': openItem === item.id, 'icon-angle-down': openItem !== item.id }"></i>
                        <button v-show="item.changed" @click.stop="searchFilterReset($event, item)" type="button"><i class="icon-times"></i></button>
                       </span>
                    </a>

                    <a v-if="getNearbyZipcodes && getNearbyZipcodes.length" class="btn filter small toggle" @click="searchFilterToggle($event, {id: '#zipCodesList' })">{{molang('search.filter.zipCodes')}}</a>
                    <a v-if="getNearbyNeighborhood && getNearbyNeighborhood.length" class="btn filter small toggle" @click="searchFilterToggle($event, {id: '#neighborhoodsList' })">{{molang('search.filter.neighborhoods')}}</a>
                    <a v-if="getNearbyCities && getNearbyCities.length" class="btn filter small toggle" @click="searchFilterToggle($event, {id: '#citiesList' })">{{molang('search.filter.cities')}}</a>
                    <a v-if="getNearbyCounties && getNearbyCounties.length" class="btn filter small toggle" @click="searchFilterToggle($event, {id: '#countiesList' })">{{molang('search.filter.counties')}}</a>
                    <button id="searchSave" type="button" class="btn primary small"  @click="saveSearch"><i class="icon-bookmark-o"></i>{{ molang('search.filter.saveSearch') }}</button>
                </div>
            </div>
        </div>
        <div class="search-filter-fixed left" :class="{'btn-icon-only': scrolled}">
            <searchSwitchView id="btnSwitchView" class="btn filter small btn-icon hidden-xs" ></searchSwitchView>
            <button type="button" id="btnFilter" class="btn filter small btn-icon" :class="{ active: !!filterCount, square: filterRedesignEnabled }" @click="searchFilterOpen" >
                <i class="icon-slider"></i>
                <span v-text="molang('search.filter.filter')"></span>
                <i v-if="filterCount" class="filter-count" v-text="filterCount"></i>
            </button>
            <button type="button" id="reset"  class="btn filter small" @click="resetFilter">{{molang('search.moreFilter.reset')}}</button>
        </div>
        <div class="search-filter-fixed right" :class="{'btn-icon-only': scrolled}">
            <button type="button" class="btn primary small" @click="saveSearch">{{ molang('search.filter.saveSearch') }}</button>
        </div>
    </div>
</template>

<script src="./search-filter.js"></script>

<style lang="scss">
@use "./search-filter.scss" as *;
</style>